import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import Text from 'components/common/Text'
import { Container, Row, Col } from 'react-bootstrap'

export const WhyPartnerBlock = () => {
	const { data: tenantProfile } = useTenantProfile()
	const tenantName = tenantProfile?.name
	const secondaryColor = tenantProfile?.theme?.secondaryColor

	return (
		<Container style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
			<Row>
				<Col>
					<Text
						size={34}
						style={{
							fontWeight: 'bold',
							textAlign: 'center',
						}}
					>
						Why become a <span style={{ color: secondaryColor }}>{tenantName}</span> Partner?
					</Text>
				</Col>
			</Row>
			<Row>
				<Col>
					<Text size={26} align='center' color={secondaryColor} style={{ fontWeight: 'bold' }}>
						Fact #1
					</Text>
					<Text size={18} align='center'>
						No homeowner wants to pay a dollar more than they have to in property taxes.
					</Text>
				</Col>
				<Col>
					<Text size={26} align='center' color={secondaryColor} style={{ fontWeight: 'bold' }}>
						Fact #2
					</Text>
					<Text size={18} align='center'>
						Many homeowners don't know they can lower their property taxes or don't know how.
					</Text>
				</Col>
				<Col>
					<Text size={26} align='center' color={secondaryColor} style={{ fontWeight: 'bold' }}>
						Fact #3
					</Text>
					<Text size={18} align='center'>
						All homeowners love working with a business that has their best interest at heart.
					</Text>
				</Col>
			</Row>
			<Row style={{ marginTop: 10 }}>
				<Col xs={12} md={{ span: 8, offset: 2 }}>
					<Text size={18} align={'center'}>
						As a <span style={{ color: secondaryColor }}>{tenantName}</span> partner, you show
						commitment to clients' financial wellbeing by helping them relax when they open their
						property tax bill. Clients see you as their real estate hero, stay loyal and recommend
						your services to others. And with no fees to become a partner, it's all upside for you!
					</Text>
				</Col>
			</Row>
		</Container>
	)
}
